<template>
    <div>
        <div class="pwa-update-install">
            <div class="install-header">
                <span class="close-btn" @click="closeInstructions">✖</span>
            </div>
            <div class="header">
                {{ $t('pwaInstructions.popupTitle') }}
            </div>
            <img src="@/assets/common/iosPwa.jpg" style="width: 280px; height: 290px;" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineEmits } from 'vue';

const emit = defineEmits(['close-instructions']);

const closeInstructions = () => {
    emit('close-instructions');
}
</script>

<style scoped>
.pwa-update-install {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #F2F2F4;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 1001;
    padding: 1rem;
    border-radius: 0.5rem;
    text-align: center;
    width: 70%;
    max-width: 400px;
}

.install-header {
    width: 100%;
    text-align: right;
}

.close-btn {
    font-size: 1.2rem;
    color: rgb(0, 0, 0);
    cursor: pointer;
}

.header {
    width: 100%;
    text-align: center;
    font-weight: 600;
    color: #000;
    padding-bottom: 10px;
}
</style>